import { render, staticRenderFns } from "./Hroquenro.vue?vue&type=template&id=22d5d4b4&scoped=true&lang=pug&"
import script from "./Hroquenro.vue?vue&type=script&lang=js&"
export * from "./Hroquenro.vue?vue&type=script&lang=js&"
import style0 from "./Hroquenro.vue?vue&type=style&index=0&id=22d5d4b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d5d4b4",
  null
  
)

export default component.exports
import {QPage,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBtn})
